class MainPopup extends HTMLElement {
  constructor() {
        super()
        this.buttonGroup = document.querySelectorAll(".open-popup-button")
        this.popupDom = this.querySelector(".main-popup")
        this.closeButton = this.querySelector(".main-popup-close")
        this.init()
    }
    
    init(){
        this.buttonGroup.forEach((item)=>{
            item.addEventListener("click",()=>{
                this.open()
            })
        })
        this.closeButton.addEventListener("click",()=>{
            this.close()
        })
    }

    open(){
        this.popupDom.classList.add("active")
        document.querySelector("body").style.overflow="hidden"
    }

    close(){
        this.popupDom.classList.remove("active")
        document.querySelector("body").style.overflow="auto"
    }
}

reg("main-popup", MainPopup);